@if (loading()) {
  <div class="app-loading" role="status">
    <span class="portal-spinner app-loading__spinner" aria-hidden="true"></span>
    <span class="app-loading__text">Carregando o portal...</span>
  </div>
}
<router-outlet></router-outlet>
